<template>
  <section>
    <div
      ref="about"
      class="font-sf-pro text-base lg:text-lg !leading-[26px]"
      :class="isShow ? 'showDetails' : 'hideDetails'"
      v-html="data"
    />

    <div
      class="w-fit text-base text-primary-100 cursor-pointer font-sf-pro"
      @click="showDetails()"
    >
      {{ text }}
    </div>
  </section>
</template>

<script setup lang="ts">
defineProps({
  data: {
    type: String,
    default: () => ''
  }
})

// @ts-ignore
const about = ref<HTMLElement>(null)
const text = ref('')

onMounted(() => {
  if (about.value.scrollHeight <= 80) {
    text.value = ''
  } else {
    text.value = 'Показать еще'
  }
})

function showDetails () {
  isShow.value = !isShow.value
  if (isShow.value) {
    about.value.style.height = about.value.scrollHeight + 'px'
    text.value = 'Скрыть'
  } else {
    about.value.style.height = 80 + 'px'
    text.value = 'Показать еще'
  }
}
const isShow = ref(false)
</script>

<style>
.hideDetails {
  transition: all 0.15s ease-out;
  overflow: hidden;
  height: 80px;
  /* display: -webkit-box; */
  /* line-clamp: 4;
  -webkit-line-clamp: 4; */
  /* -webkit-box-orient: vertical; */
}

.showDetails {
  overflow: hidden;
  transition: all 0.15s ease-out;
}
</style>
